import { useEffect, useState } from 'react';
import { navLinks, marqueeItems } from '@/mocks/drama';

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [dark, setDark] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    if (dark) root.classList.add('dark');
    else root.classList.remove('dark');
  }, [dark]);

  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      {/* update ticker */}
      <div className="bg-primary-600 text-background-50 dark:text-foreground-950">
        <div className="flex items-center h-8 overflow-hidden">
          <span className="hidden sm:flex items-center gap-2 h-8 px-4 shrink-0 bg-primary-700 font-label text-xs font-medium">
            <i className="ri-broadcast-line text-sm" aria-hidden="true" />
            更新提示
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="animate-marquee flex w-max items-center">
              {[...marqueeItems, ...marqueeItems].map((item, index) => (
                <span key={`${item}-${index}`} className="flex items-center font-label text-xs whitespace-nowrap px-6">
                  <i className="ri-film-line mr-2 text-accent-300" aria-hidden="true" />
                  {item}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* nav bar */}
      <div
        className={`transition-colors duration-300 ${
          scrolled
            ? 'bg-background-50/95 backdrop-blur border-b border-background-200'
            : 'bg-gradient-to-b from-foreground-950/70 to-transparent'
        }`}
      >
        <div className="mx-auto flex items-center gap-4 px-4 md:px-6 h-16">
          <a href="#top" className="flex items-center gap-2 shrink-0 cursor-pointer">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950">
              <i className="ri-vidicon-line text-lg" aria-hidden="true" />
            </span>
            <span className={`font-heading text-base md:text-lg font-bold whitespace-nowrap ${scrolled ? 'text-foreground-950' : 'text-background-50'}`}>
              漂亮的小姨子
            </span>
          </a>

          <nav className="hidden lg:flex flex-1 items-center justify-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                className={`px-3 py-2 rounded-md font-label text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  scrolled
                    ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-100/60'
                    : 'text-background-100 hover:text-accent-300 hover:bg-foreground-950/30'
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="ml-auto flex items-center gap-2">
            <button
              type="button"
              onClick={() => setDark((v) => !v)}
              aria-label={dark ? '切换到浅色模式' : '切换到深色模式'}
              className={`flex h-9 w-9 items-center justify-center rounded-md border transition-colors cursor-pointer ${
                scrolled
                  ? 'border-background-300 text-foreground-700 hover:bg-background-100'
                  : 'border-background-50/40 text-background-50 hover:bg-foreground-950/30'
              }`}
            >
              <i className={dark ? 'ri-sun-line text-lg' : 'ri-moon-line text-lg'} aria-hidden="true" />
            </button>
            <a
              href="#episodes"
              className="hidden sm:flex items-center gap-1 rounded-md bg-accent-500 px-4 py-2 font-label text-sm font-medium text-accent-950 hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line" aria-hidden="true" />
              看全集导览
            </a>
            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              aria-label="打开导航菜单"
              aria-expanded={menuOpen}
              className={`lg:hidden flex h-9 w-9 items-center justify-center rounded-md border cursor-pointer ${
                scrolled ? 'border-background-300 text-foreground-700' : 'border-background-50/40 text-background-50'
              }`}
            >
              <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} aria-hidden="true" />
            </button>
          </div>
        </div>

        {menuOpen ? (
          <div className="lg:hidden bg-background-50 border-t border-background-200 px-4 py-3">
            <div className="grid grid-cols-2 gap-1">
              {navLinks.map((link) => (
                <a
                  key={link.id}
                  href={`#${link.id}`}
                  onClick={() => setMenuOpen(false)}
                  className="px-3 py-2 rounded-md font-label text-sm text-foreground-700 hover:bg-primary-100/60 hover:text-primary-700 cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        ) : null}
      </div>
    </header>
  );
}